import { Permission } from '@common/permissions';
import React, { useEffect } from 'react';
import { useSession } from 'src/apps/invest/common/hooks/useSession';
import { useInboxModel } from '../../../../common/models/InboxModel';
import { useInvestorAccountModel } from '../../../../common/models/InvestorAccountModel';
import { usePermissions } from '../../common/hooks/usePermissions';
import { useDashboardModel } from '../models/DashboardModel';
import { DashboardPage } from '../views/DashboardPage';

const permissions: Permission[] = ['ACCREDITED_INVESTOR', 'UNACCREDITED_INVESTOR'];
const sessionRedirect = `${window.location.pathname}${window.location.search}`;

export const DashboardController: React.FC = () => {
  const { checkAuthenticated } = useSession();
  const { checkPermissions } = usePermissions();

  const model = useDashboardModel();
  const investorAccountModel = useInvestorAccountModel();
  const inboxModel = useInboxModel();

  const init = async () => {
    if (!(await checkAuthenticated(sessionRedirect))) return;
    if (!(await checkPermissions(permissions))) return;

    model.setLoading(true);
    //TODO: Rely on the router's call to the kitchen sink API to have fetched these values.

    const investorAccount = investorAccountModel.investorAccount;

    await model.fetchInvestments(); //TODO: MOVE TO A COMMON MODEL
    // Still need to do this stuff in the view model
    inboxModel.checkForAlerts(investorAccount);
    model.setLoading(false);
  };

  useEffect(() => {
    init();
  }, []);

  return <DashboardPage />;
};
